import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw, useTranslate } from '../../lib'
// import AsideBar from './AsideBar'

import './info-call.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
import ComplianceHits from './ComplianceHits'
import ComplianceImprovents from './ComplianceImprovents'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"
import LoadingReport from './LoadingReport'

export default function CallReportResume(props) {
    const { data, onSeekToTime, onQualificationUpdate, sessionCode } = props
    const [loading, setLoading] = useState(false)
    const [call, setCall] = useState(data)
    // Estado para toggles controlados
    const [toggles, setToggles] = useState({});
    const [positive, setPositive] = useState(0)
    const [neutro, setNeutro] = useState(0)
    const [negative, setNegative] = useState(0)
    const [total, setTotal] = useState(0)
    const [minimumPassingScore, setMinimumPassingScore] = useState(0);
    const { t } = useTranslate();

    useEffect(() => {
        setCall(data)
        setMinimumPassingScore(JSON.parse(localStorage.getItem('report_project_selected')).minimum_passing_score);

        // Inicializar toggles controlados
        const togglesInit = {};
        const addToggles = (arr, section, from) => {
            arr?.forEach(item => {
                const key = `${section}|${from}|${item.used_phrase || item.intent}`;
                togglesInit[key] = item.isCorrect !== undefined ? !!item.isCorrect : true;
            });
        };
        addToggles(data?.assesment?.compliance?.hits, 'compliance', 'hits');
        addToggles(data?.assesment?.resolution?.hits, 'resolution', 'hits');
        addToggles(data?.assesment?.disclaimer?.hits, 'disclaimer', 'hits');
        addToggles(data?.assesment?.compliance?.improvements, 'compliance', 'improvements');
        addToggles(data?.assesment?.resolution?.improvements, 'resolution', 'improvements');
        addToggles(data?.assesment?.disclaimer?.improvements, 'disclaimer', 'improvements');
        setToggles(togglesInit);

        let positive_count = 0
        let negative_count = 0
        let neutro_count = 0
        let total_sum = 0 
        data?.sentiment?.map((item, idex) => {
            if (item.polarity == 'POS') {
                positive_count = positive_count + 1
                total_sum = total_sum + 1
            }
            else if (item.polarity == 'NEU') {
                neutro_count = neutro_count  + 1
                total_sum = total_sum + 0
            }
            else if (item.polarity == 'NEG') {
                negative_count = negative_count  + 1
                total_sum = total_sum - 1
            }
        })
        setNegative(negative_count)
        setPositive(positive_count)
        setNeutro(neutro_count)
        const score = (total_sum/ (data?.sentiment?.length || 1 ))
        setTotal(((score + 1) / 2).toFixed(2))
    }, [data])

    const [categories, setCategories] = useState([])

    useEffect(() => {
        if (!call?.assesment?.resolution) return;
        const hitsArr = call.assesment.resolution.hits || [];
        const improvementsArr = call.assesment.resolution.improvements || [];
        const allCategories = [
            ...hitsArr.map(i => i.category),
            ...improvementsArr.map(i => i.category)
        ].filter(Boolean);
        const uniqueCategories = Array.from(new Set(allCategories));
        const categoriesData = uniqueCategories.map(cat => ({
            id: cat?.toLowerCase?.() || cat,
            name: cat?.charAt(0).toUpperCase() + cat?.slice(1).toLowerCase(),
            hits: hitsArr.filter(i => i.category === cat).map(i => ({
                ...i,
                class: getHitsClass(i.accuracy)
            })),
            improvements: improvementsArr.filter(i => i.category === cat).map(i => ({
                ...i,
                class: getImprovementsClass(i.accuracy)
            }))
        }));
        setCategories(categoriesData);
    }, [call]);

    function getHitsClass(acurracy) {
        if (acurracy < 50) return 'red';
        else if (acurracy > 50 && acurracy <= 79) return 'orange';
        else if (acurracy > 79) return 'green';
        return '';
    }
    function getImprovementsClass(acurracy) {
        if (acurracy < 50) return 'red';
        else return 'orange';
    }

    const handleToggle = async (item, section, from) => {
        // Optimistic update
        const key = `${section}|${from}|${item.used_phrase || item.intent}`;
        setToggles(prev => ({ ...prev, [key]: !prev[key] }));
        setLoading(true);
        try {
            const question = item.used_phrase || item.intent
            const config = { headers: { apikey: 'validApikey' } }
            const res = await axios.post(`${urlValue}/assesment/toggle-question`, {
                sessionCode,
                question,
                section,
                from
            }, config)

            if (res.status === 200) {
                const updated = res.data.evaluations
                updated.qualification = res.data.newQualification
                await new Promise(resolve => setTimeout(resolve, 400));
                if (onQualificationUpdate) {
                    onQualificationUpdate({ assesment: updated.assesment, qualification: updated.qualification })
                }
            }
        } catch (error) {
            // Revert optimistic update on error
            setToggles(prev => ({ ...prev, [key]: !prev[key] }));
            console.error('Error toggling question:', error)
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {loading && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <LoadingReport />
                </div>
            )}
            <div className="info-call w-full" style={{ backgroundColor: 'white', paddingTop: 10 }}  >
                <div className="info-call-item header">
                    <div className="d-flex flex-column">
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <h4 style={{fontWeight: "bold",color: "#4d4d4d", fontSize: 16}}>{t('common.scoreMayus')}:</h4>
                            <div className="porcentaje ml-3" 
                                style={{color: '#0B5FA3', fontSize: 20, fontWeight: "bold", whiteSpace: 'nowrap'}}>
                                {Number((call.qualification * 100).toFixed(1))}% 
                            </div>
                        </div>
                        {(call?.autoFailEvaluation || 0) == 1 && <div style={{fontSize: 12}}>{t('reports.autoFailMessage')}</div>}
                        <div style={{fontSize: 12}}>{minimumPassingScore}{t('reports.percentageMinimun')}</div>
                        <div style={{marginTop: 10, color: 'white'}}>
                            {Number((Number((call?.qualification || 0)) * 100).toFixed(1)) < Number(minimumPassingScore) 
                                ? <div style={{background: 'red', padding: 5, borderRadius: 25, textAlign: 'center'}}>{t('reports.failed')}</div> 
                                : <div style={{background: 'green', padding: 5, borderRadius: 25, textAlign: 'center'}}>{t('reports.approved')}</div>}
                        </div>
                    </div>

                    <div style={{ padding: 10, textTransform: 'uppercase', fontSize: 14, color: "#0B5FA3" }}>
                        {/*<h4 style={{ fontSize: 18, fontWeight: "bold",color: "#0B5FA3" }}>Bot sentiment result:</h4>*/}
                        <div className="d-flex flex-row align-items-center"
                            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}} >
                            <div class="m-1" style={{ fontWeight: "bold"}}>{t('reports.positive')}:</div>
                            <div style={{ marginLeft: 3 }}>{positive}</div>
                        </div>
                        <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div style={{ fontWeight: "bold" }}>{t('reports.neutral')}:</div>
                            <div style={{ marginLeft: 3 }}>{neutro}</div>
                        </div>
                        <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div style={{ fontWeight: "bold" }}>{t('reports.negative')}:</div>
                            <div style={{ marginLeft: 3 }}>{negative}</div>
                        </div>
                        <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <div class="m-1" style={{ fontWeight: "bold" }}>{t('reports.sentiment')}:</div>
                            <div style={{ marginLeft: 3, letterSpacing: 1 }}>{(total * 100).toFixed(2)}%</div>
                        </div>
                    </div>

                    <div className="time-metrics-container">
                        <div className="time-metric-box">
                            <h4 className='font-bold text-[#0B5FA3] uppercase' style={{fontSize: 13}}>{t('reports.totalTimeCall')}</h4>
                            <div className='text-[#0B5FA3] w-100 text-bold' style={{textAlign: 'right', fontSize: 24}}>
                                {call.time_call}
                            </div>
                        </div>
                        <div className="time-metric-box">
                            <h4 className='font-bold text-[#0B5FA3] uppercase' style={{fontSize: 13}}>{t('reports.timesInHold')}</h4>
                            <div className='text-[#0B5FA3] w-100 text-bold' style={{textAlign: 'right', fontSize: 24}}>
                                {call?.time_hold || 0}
                            </div>
                        </div>
                        <div className="time-metric-box">
                            <h4 className='font-bold text-[#0B5FA3] uppercase' style={{fontSize: 13}}>{t('reports.totalHoldTime')}</h4>
                            <div className='text-[#0B5FA3] w-100 text-bold' style={{textAlign: 'right', fontSize: 24}}>
                                {call?.second_hold || 0}
                            </div>
                        </div>
                    </div>


                </div>

                {(call?.short_conversation || 0) == 1 &&
                <div class="info-call-item body">
                    <h6 className="font-bold">
                        {t('reports.shortConversation')}
                    </h6>
                </div>}
                {(call?.short_conversation || 0) == 0 &&
                <div
                    className="info-call-item body"
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 16,
                        maxHeight: '45vh',
                        overflowY: 'auto',
                        minHeight: 200
                    }}
                >
                    <div style={{ width: '100%', marginLeft: 24, marginRight: 24 }}>
                        <div style={{ display: 'flex', gap: 32, marginBottom: 16 }}>
                            <div style={{ flex: 1, textAlign: 'center' }}>
                                <h2 style={{ color: '#0B5FA3', fontSize: 22, marginBottom: 8, fontWeight: 'bold' }}>{t('reports.hits')}</h2>
                            </div>
                            <div style={{ flex: 1, textAlign: 'center' }}>
                                <h2 style={{ color: '#0B5FA3', fontSize: 22, marginBottom: 8, fontWeight: 'bold' }}>{t('reports.improvements')}</h2>
                            </div>
                        </div>
                        {categories.length === 0 ? (
                            <div style={{ display: 'flex', gap: 32 }}>
                                <div style={{ flex: 1, paddingRight: 20 }}>
                                    <ComplianceHits data={call} onSeekToTime={onSeekToTime} onToggle={handleToggle} toggles={toggles} />
                                </div>
                                <div style={{ flex: 1, paddingLeft: 20 }}>
                                    <ComplianceImprovents data={call} onToggle={handleToggle} toggles={toggles} onSeekToTime={onSeekToTime} />
                                </div>
                            </div>
                        ) : (
                            categories.map(cat => (
                                <div key={cat.id} style={{ boxShadow: 'inset 0 0 0 2px #0B5FA3', borderRadius: 12, marginBottom: 24, padding: 16, background: '#f8fbfd', display: 'flex', alignItems: 'flex-start' }}>
                                    <div style={{ flex: 1, paddingRight: 20 }}>
                                        <h3 style={{ color: '#0B5FA3', marginBottom: 8, textAlign: 'left', fontWeight: 'bold' }}>{cat.name}</h3>
                                        <ComplianceHits data={{
                                            ...call,
                                            assesment: {
                                                ...call.assesment,
                                                resolution: {
                                                    ...call.assesment?.resolution,
                                                    hits: cat.hits
                                                }
                                            }
                                        }} onSeekToTime={onSeekToTime} onToggle={handleToggle} toggles={toggles} />
                                    </div>
                                    <div style={{ flex: 1, paddingLeft: 20 }}>
                                        <h3 style={{ color: '#0B5FA3', marginBottom: 8, textAlign: 'left', visibility: 'hidden', fontWeight: 'bold' }}>{cat.name}</h3>
                                        <ComplianceImprovents data={{
                                            ...call,
                                            assesment: {
                                                ...call.assesment,
                                                resolution: {
                                                    ...call.assesment?.resolution,
                                                    improvements: cat.improvements
                                                }
                                            }
                                        }} onSeekToTime={onSeekToTime} onToggle={handleToggle} toggles={toggles} />
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>}
            </div>
        </>

        
    )
}
